<div #firstParent class="canvas h-100">
    <div class="canvas-container h-100" #canvasContainer>
        <canvas #canvas></canvas>
    </div>
</div>
<neo4j-context-menu [document]="this.savedDocument" [selectedShape]="currentFocus" [selectedRelation]="currentConnectionFocus" [callback]="makeAction"></neo4j-context-menu>

@if (viewFromServer) {
    <data-view-actions [mainComponent]="appComponent" [dataViewer]="this" [currentTabType]="TabType.MODEL_CREATOR"></data-view-actions>
}
<center-canvas [centerAction]="fitBoxesWithCamera"></center-canvas>
@if (isLoading) {
    <div class="h-100 d-flex justify-content-center align-items-center loading">
        <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    </div>
}
<app-task-notification-bar [isRightMenuActive]="!!appComponent.rightMenu.isOverviewActive"></app-task-notification-bar>
